type TrustedByLogosProps = {
  containerClasses?: string;
  imageClasses?: string;
};

const TRUSTED_BY_LOGOS = [
  { slug: "mass-retirees", name: "Mass Retirees" },
  { slug: "cancer-support-community", name: "Cancer Support Community" },
  { slug: "imerman-angels", name: "Imerman Angels" },
  { slug: "unite-for-her", name: "Unite for HER" },
  { slug: "twist-out-cancer", name: "Twist Out Cancer" },
  { slug: "teen-cancer-america", name: "Teen Cancer America" },
];

export const TrustedByLogos = ({ containerClasses, imageClasses }: TrustedByLogosProps) => {
  return (
    <div className={containerClasses}>
      {TRUSTED_BY_LOGOS.map(({ name, slug }) => {
        return (
          /*
            Partner artwork is black-on-transparent and disappears against a dark
            page, so in dark mode each logo sits on the light plate it was drawn for.
          */
          <span
            className="flex items-center justify-center rounded-lg dark:bg-white dark:px-4 dark:py-2"
            key={slug}
          >
            <img alt={name} className={imageClasses} src={`/assets/images/${slug}.png`} />
          </span>
        );
      })}
    </div>
  );
};
